// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const pugPackage = require('../../../package.json');

export const environment = {
  froalaKey: '3B11C5A4C4gC3E3A2D3B7A4C3F4B2D1zHMDUGENKACTMXQL==',
  production: false,
  apiBaseUrl: 'https://storpug-api.herokuapp.com/api/v1/',
  env: 'dev',
  lambdaApi: "https://vovs5a6lw4.execute-api.us-east-1.amazonaws.com/dev/",
  lambdaApiCache: "https://vovs5a6lw4.execute-api.us-east-1.amazonaws.com/dev/",
  // apiBaseUrl: 'http://localhost:3000/api/v1/',
  textApi: 'https://us-central1-storpug-dev.cloudfunctions.net/sendTextMessage/',
  version: pugPackage.version,
  gm: 'AIzaSyB1-z31tSZWe9EFqsEWExQgG_o4DtzdMtQ',
  firebase: {
    apiKey: "AIzaSyCRMZKRtaM_yfeuRP_nY7ZSPvWimXKsBvo",
    authDomain: "storpug-dev.firebaseapp.com",
    databaseURL: "https://storpug-dev.firebaseio.com",
    projectId: "storpug-dev",
    storageBucket: "storpug-dev.appspot.com",
    messagingSenderId: "187390999159"
  },
  aws: {
    "accessKeyId": "AKIAJMEGZGPFENR6FQTA",
    "secretAccessKey": "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",
    "region": "us-east-1"
  }
};



// WEBPACK FOOTER //
// ./src/ng2/environments/environment.ts